import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=e641d280&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=e641d280&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e641d280",
  null
  
)

export default component.exports